import { render, staticRenderFns } from "./PlayGames.vue?vue&type=template&id=4c416dba&"
import script from "./PlayGames.vue?vue&type=script&lang=js&"
export * from "./PlayGames.vue?vue&type=script&lang=js&"
import style0 from "./PlayGames.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports